module.exports = __webpack_public_path__ + "static/solutionMiddle-10147cd57402b683aabc3a51d75944df.png";